import { createVNode as _createVNode } from "vue";
/**
 * @author wuluoting
 * @fileoverview 左侧边二维码
 */

import { defineComponent, ref } from "vue";
// assets
import rightBtnUrl from "@/assets/img/pc/code-right.png";
import leftBtnUrl from "@/assets/img/pc/code-left.png";
import downloadBtnUrl from "@/assets/img/pc/code-download-btn.png";
import codeAreaUrl from "@/assets/img/pc/code-area.png";
export default defineComponent({
  name: "SideCode",
  setup() {
    const showCodeBox = ref(true);
    const toggleRightBtn = () => {
      showCodeBox.value = !showCodeBox.value;
    };
    const downloadApp = () => {
      let a = document.createElement("a");
      a.href = "https://apks.shiyuegame.com/cahxstarter/20230505/cahxstarter.exe";
      a.download = "cahxstarter.exe";
      a.click();
    };
    return () => {
      return _createVNode("div", {
        "class": "pc-explain code-box"
      }, [_createVNode("div", {
        "onClick": () => {
          toggleRightBtn();
        }
      }, [!showCodeBox.value ? _createVNode("img", {
        "class": "right-btn arrow",
        "src": rightBtnUrl
      }, null) : _createVNode("img", {
        "class": "left-btn arrow",
        "src": leftBtnUrl
      }, null)]), _createVNode("div", {
        "class": ["code-content", showCodeBox.value ? "animate__fadeInLeft" : "animate__fadeOutLeft"]
      }, [_createVNode("div", {
        "class": "code-inner-bg"
      }, [_createVNode("img", {
        "class": "code-area",
        "src": codeAreaUrl
      }, null)]), _createVNode("img", {
        "class": "download-btn",
        "onClick": () => downloadApp(),
        "src": downloadBtnUrl
      }, null)])]);
    };
  }
});